module.exports = __webpack_public_path__ + "img/landing-icon-3.c40dd266.png";